import { graphql } from "../gql";

export const getProviderClaimsMetricsQueryDoc = graphql(`
  query getProviderClaimsMetrics {
    providerClaimsMetrics {
      providerNpi
      providerName
      providerId
      claimsReviewed
      claimsUnderReview
      claimsAwaitingDocumentation
      claimsAwaitingIngestion
    }
  }
`);
